import React, { Component } from "react";
import { StaticQuery, graphql, Link} from 'gatsby'
import firebase from "firebase";
import "firebase/auth";
import {
  FirebaseAuthProvider,
  IfFirebaseAuthed,
  IfFirebaseUnAuthed,
} from "@react-firebase/auth";
import { config } from "../../config";
import { translate } from "react-i18next"

class CreateProfile extends Component {
  constructor(props) {
    super(props);
    this.showMessage = this.showMessage.bind(this);
    this.state = 
    {
        message: "",
    };
  }

  showMessage(message) {
    this.setState({
        message: message,
    });
  }

  render() {
    const { t } = this.props
    return (
      <StaticQuery
        query={graphql`
          query CreateProfileQuery {
            site {
              siteMetadata {
                shortTitle
              }
            }
          }
        `}
        render={data => (
                <FirebaseAuthProvider {...config} firebase={firebase}>
                            <IfFirebaseUnAuthed>
                            {({isSignedIn, user, providerId}) => {
                                var bla = isSignedIn + " - " + user + " - " + providerId;
                                return (
                                <section id="two" className="cards-top">
                                <div className="inner">
                                    <header className="major">
                                    <h2>{t("create_profile_title", "Erstelle dein Profil")}</h2>
                                    </header>
                                    <p>{t("create_profile_subtitle", "Zeig dich! Erstelle dein Profil, es ist ganz einfach. Und kostenlos.")}</p>
                                    <p>{t("create_profile_text1", "Erzähle von dir und deinem Unternehmen: Warum hast du gegründet? Was bietest du an? So wird Besucherinnen der Seite der Weg zu dir gewiesen.")}</p>
                                    <ul className="actions">
                                      <li>
                                          <Link
                                          aria-label="Link to Register Page"
                                          to="/register"
                                          className="button next"
                                          >
                                          {t("create_profile_button1", "Profil erstellen")}
                                          </Link>
                                      </li>
                                    </ul>
                                    <p>{t("create_profile_text2", "Wenn du bereits registriert bist, kannst du dich hier anmelden:")}</p>
                                    <ul className="actions">
                                      <li>
                                          <Link
                                          aria-label="Link to Login Page"
                                          to="/login"
                                          className="button next"
                                          >
                                          {t("create_profile_button2", "Anmelden")}
                                          </Link>
                                      </li>
                                    </ul>
                                </div>
                                </section>
                              )}}
                            </IfFirebaseUnAuthed>

                            <IfFirebaseAuthed>
                            {({isSignedIn, user, providerId}) => {
                                var bla = isSignedIn + " - " + user + " - " + providerId;
                                return (
                                <section id="two" className="cards-top">
                                    <div className="inner">
                                      <div className="grid-wrapper">
                                        <div className="col-4">
                                          <header className="major">
                                            <h2>{t("create_profile_auth_title", "Dein Profil")}</h2>
                                          </header>
                                            <p>{t("create_profile_auth_text", "Möchtest du dein Profil ansehen oder bearbeiten?")}</p>
                                            <ul className="actions">
                                              <li>
                                              <Link
                                                  aria-label="Link to Profile Page"
                                                  to="/profile"
                                                  className="button next"
                                              >
                                                  {t("create_profile_auth_button", "Mein Profil")}
                                              </Link>
                                              </li>
                                          </ul>
                                        </div>
                                        <div className="col-4">
                                        </div>
                                        <div className="col-4">
                                        {user.photoURL ? (
                                        <span className="image"><img className="profilepic" src={user.photoURL} alt="Profilbild"/></span>
                                            ) : (
                                                <span></span>
                                            )}
                                        </div>
                                    </div>
                                  </div>
                                </section>
                            )}}
                            </IfFirebaseAuthed>
                    </FirebaseAuthProvider>
                )}
            />
        )
    }
} 

export default translate("Index")(CreateProfile)